import { Component, OnInit } from '@angular/core';
import { AppointmentWeeklyCalenderComponent } from '../appointment-weekly-calender/appointment-weekly-calender.component';

@Component({
  selector: 'app-dashboard',
  imports: [AppointmentWeeklyCalenderComponent],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss'
})
export class DashboardComponent implements OnInit {
  ngOnInit(): void {}
}
